import { useEffect, useState } from "react";
import { Toast } from "flowbite-react";
import { HiExclamation, HiCheck, HiInformationCircle } from "react-icons/hi";
import { ToastToggle } from "flowbite-react/lib/esm/components/Toast/ToastToggle";

const iconMap = {
  warning: HiExclamation,
  success: HiCheck,
  info: HiInformationCircle,
};

const bgMap = {
  warning: "bg-[#fff3cd] text-[#856404]",
  error: "bg-red-100 text-red-800",
  success: "bg-green-100 text-green-800",
  info: "bg-blue-100 text-blue-800",
};

const iconBgMap = {
  warning: "bg-yellow-200 text-yellow-800",
  error: "bg-red-200 text-red-800",
  success: "bg-green-200 text-green-800",
  info: "bg-blue-200 text-blue-800",
};

const CustomToast = ({
  message,
  type = "warning",
  duration = 5000,
  onClose,
}) => {
  const [visible, setVisible] = useState(true);
  const Icon = iconMap[type] || HiExclamation;

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div
      className={`z-[10001] fixed top-5 right-5 z-50 transition-opacity duration-700 ease-out ${
        visible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <Toast className={`shadow-lg ${bgMap[type]} border border-gray-300`}>
        <div
          className={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${iconBgMap[type]}`}
        >
          <Icon className="h-5 w-5" />
        </div>
        <div className="ml-3 text-sm font-medium">{message}</div>
        <ToastToggle
          onDismiss={() => {
            setVisible(false);
            if (onClose) onClose();
          }}
        />
      </Toast>
    </div>
  );
};

export default CustomToast;
